<template>
  <div
    v-if="student && student.id"
    class="d-flex flex-row flex-nowrap align-center py-2"
    @click="$emit('change', student)"
  >
    <div v-if="!$vuetify.breakpoint.mobile" class="image-wrapper mr-2">
      <img :src="avatar" alt="" />
    </div>
    <div>
      <router-link style="text-decoration: none" v-if="isLink && !isError && student.id" :to="'/student/' + student.id">
        <div style="white-space: nowrap">
          {{ student.name }}
        </div>
      </router-link>

      <div class="black--text" style="white-space: nowrap" v-else>{{ student.name }}</div>
      <div v-if="isShowCode" style="white-space: nowrap; color: #797979;">
        <span>{{ code }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { get, padStart } from 'lodash'
import { mapGetters, mapState } from 'vuex'

export default {
  props: {
    student: Object,
    prepend: Object,
    append: Object,
    attendance: Object,
    link: Boolean,
    isShowCode: {
      type: Boolean,
      default: true
    },
    isError: Boolean,
    isGlobalCodeShown: Boolean
  },
  computed: {
    ...mapGetters('auth', ['ownClassIds']),
    ...mapState('auth', ['role']),
    avatar() {
      return get(this.student, 'avatar.url', '/default-avatar.svg')
    },
    isLink() {
      if (this.role.type === 'teacher') {
        let classId = get(this.student, 'currentClass.id')
        if (!classId) classId = get(this.student, 'currentClass')
        if (Array.isArray(this.ownClassIds) && this.ownClassIds.length) return this.ownClassIds.includes(classId)
        return false
      }
      return this.link && this.$auth.policies['view-student-group']
    },
    code() {
      if (this.isGlobalCodeShown) return this.student.code
      return padStart(this.student.index, 5, '0')
    }
  }
}
</script>

<style lang="scss" scoped>
.image-wrapper {
  width: 55px;
  min-width: 55px;
  height: 55px;
  display: flex;
  align-items: center;
  border-radius: 4px;
  justify-content: center;
  img {
    max-width: 100%;
    max-height: 100%;
    border-radius: 4px;
  }
}
</style>
